export const MIN_TIME = 6
export const MAX_TIME = 21
export const MIN_TIME_DISPLAYED = '06:00:00'
export const MAX_TIME_DISPLAYED = '21:00:00'

export const CALENDAR_VIEW_MONTH = 'dayGridMonth'
